export const initNav = () => {

	const container = document.querySelector('.Nav') as HTMLElement;

	if (container) {
		
		const navItems = [...container.querySelectorAll('.Nav-item')] as HTMLElement[];
		const visibleTargets = new Map<string, number>();

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				visibleTargets.set(entry.target.id, entry.intersectionRatio);
			})

			const mostVisible = [...visibleTargets.entries()].reduce((a, b) =>
                a[1] > b[1] ? a : b
            );

			navItems.forEach((navItem) => {
                navItem.classList.toggle('is-active', navItem.dataset.target === mostVisible[0]);
            });
		}, { threshold: Array.from({ length: 11 }, (_, i) => i / 10) });

		navItems.forEach((navItem) => {
            const target = document.querySelector(`#${navItem.dataset.target}`);
            if (target) observer.observe(target);
        });
	}
}